/* CamGuard homepage product shelves (26.09.2026): polish shared by "Most viewed." and
   "A few things you might like." Nothing here hides or moves the words or the price.
   - Desktop: the product photo tile tilts a few degrees toward the cursor, with a soft light on it.
   - Click: the photo is handed to the theme's product-image View Transition, so it morphs into the
     product page's main image (the theme skips it on weak devices and in-app browsers).
   - Stars: cards drawn later by the recommendation runtime get the same rating line as the Liquid
     cards, from the map the recommendations section prints (4.5 or better from 3+ reviews only). */
(() => {
  if (window.cgauShelfFx) return;
  window.cgauShelfFx = true;
  const CARD = '.cgau-mv__card, .cgau-home-recommendations__card';
  const STAGE = '.cgau-mv__stage, .cgau-home-recommendations__image';
  const fine = matchMedia('(hover: hover) and (pointer: fine)');
  const calm = matchMedia('(prefers-reduced-motion: reduce)');

  // 1. Tilt and light (transform and opacity only, one write per frame)
  let frame = 0, stage = null, point = null;
  const clamp = v => Math.min(1, Math.max(0, v));
  const paint = () => {
    frame = 0;
    if (!stage || !point) return;
    const r = stage.getBoundingClientRect();
    const x = clamp((point.x - r.left) / r.width), y = clamp((point.y - r.top) / r.height);
    stage.style.setProperty('--tilt-x', `${((.5 - y) * 10).toFixed(2)}deg`);
    stage.style.setProperty('--tilt-y', `${((x - .5) * 14).toFixed(2)}deg`);
    stage.style.setProperty('--sheen-x', `${(x * 100).toFixed(1)}%`);
    stage.style.setProperty('--sheen-y', `${(y * 100).toFixed(1)}%`);
  };
  const release = el => { el.style.removeProperty('--tilt-x'); el.style.removeProperty('--tilt-y'); el.removeAttribute('data-tilting'); };
  document.addEventListener('pointermove', e => {
    if (e.pointerType !== 'mouse' || !fine.matches || calm.matches) return;
    const card = e.target instanceof Element ? e.target.closest(CARD) : null;
    const next = card ? card.querySelector(STAGE) : null;
    if (next !== stage) { if (stage) release(stage); stage = next; if (stage) stage.setAttribute('data-tilting', ''); }
    if (!stage) return;
    point = {x: e.clientX, y: e.clientY};
    if (!frame) frame = requestAnimationFrame(paint);
  }, {passive: true});
  document.documentElement.addEventListener('pointerleave', () => { if (stage) release(stage); stage = null; });

  // 2. Photo-to-product-page morph through the theme's View Transition
  document.addEventListener('click', e => {
    const link = e.target instanceof Element ? e.target.closest('a[href*="/products/"]') : null;
    if (!link || e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const card = link.closest(CARD);
    const photo = card && card.querySelector(STAGE);
    if (!photo) return;
    document.querySelectorAll('[data-view-transition-triggered]').forEach(el => el.removeAttribute('data-view-transition-triggered'));
    photo.setAttribute('data-view-transition-type', 'product-image-transition');
    photo.setAttribute('data-view-transition-triggered', 'true');
  });

  // 3. Stars on runtime-built recommendation cards
  let ratings = {};
  try { ratings = JSON.parse((document.getElementById('cgau-shelf-ratings') || {}).textContent || '{}'); } catch (err) { ratings = {}; }
  const handleOf = card => {
    const a = card.querySelector('a[href*="/products/"]');
    const m = a && a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    try { return m ? decodeURIComponent(m[1]) : ''; } catch (err) { return ''; }
  };
  const decorate = root => root.querySelectorAll('.cgau-home-recommendations__card').forEach(card => {
    if (card.querySelector('.cgau-shelf-stars')) return;
    const r = ratings[handleOf(card)], title = card.querySelector('.cgau-home-recommendations__title');
    if (!Array.isArray(r) || !title) return;
    const score = Number(r[0]).toFixed(1), count = Number(r[1]);
    const s = document.createElement('span');
    s.className = 'cgau-shelf-stars';
    s.setAttribute('role', 'img');
    s.setAttribute('aria-label', `Rated ${score} out of 5 from ${count} reviews`);
    s.innerHTML = `<span class="cgau-shelf-stars__star" aria-hidden="true">★</span><span aria-hidden="true">${score}</span><span class="cgau-shelf-stars__count" aria-hidden="true">(${count})</span>`;
    title.insertAdjacentElement('afterend', s);
  });
  const watch = () => document.querySelectorAll('[data-cgau-recommendations-grid]').forEach(grid => {
    decorate(grid);
    if (grid.dataset.cgauStars) return;
    grid.dataset.cgauStars = '1';
    new MutationObserver(() => decorate(grid)).observe(grid, {childList: true});
  });
  watch();
  document.addEventListener('shopify:section:load', watch);
})();
